export const BROWSE_ALL_MOSAIC_IMAGES = [
  { id: '1', url: '/temp_images/browse-all/image1.webp', alt: '3D model preview', order: 1 },
  { id: '2', url: '/temp_images/browse-all/image2.webp', alt: '3D model preview', order: 2 },
  { id: '3', url: '/temp_images/browse-all/image3.webp', alt: '3D model preview', order: 3 },
  { id: '4', url: '/temp_images/browse-all/image4.webp', alt: '3D model preview', order: 4 },
]

export const browseAllMockData = {
  title: "Can't find the right collection?",
  description: 'Browse the full catalog to explore thousands of models.',
  buttonText: 'Browse all models',
  buttonHref: '/3d-models?page=1',
  images: BROWSE_ALL_MOSAIC_IMAGES,
}
